import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
function isValidCssClassName(value) {
    const regex = /-?[_a-zA-Z]+[-_a-zA-Z0-9]*$/;
    return regex.test(value);
}
// Check that the css class names are valid
export function validateCssClassName(node, nodeFields, accept) {
    const { idField, cssClassNameField } = nodeFields;
    if (cssClassNameField &&
        cssClassNameField.cssClassName?.$type === 'StringField') {
        const cssClassName = cssClassNameField.cssClassName.value;
        if (!isValidCssClassName(cssClassName)) {
            accept('error', "The 'cssClassName' needs to be in the valid format.", {
                node: cssClassNameField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.CSS_CLASS_NAME,
                },
            });
        }
    }
}
//# sourceMappingURL=validate-css-class-name.js.map